import { render, staticRenderFns } from "./Suche.vue?vue&type=template&id=471c5b01&scoped=true"
import script from "./Suche.vue?vue&type=script&lang=js"
export * from "./Suche.vue?vue&type=script&lang=js"
import style0 from "./Suche.vue?vue&type=style&index=0&id=471c5b01&prod&scoped=true&lang=css"
import style1 from "./Suche.vue?vue&type=style&index=1&id=471c5b01&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c5b01",
  null
  
)

export default component.exports